import React from 'react';

import Layout from '../components/layout';
import Testimonials from '../components/testimonials';
import About from '../components/about';
import Contact from '../components/contact';
import Work from '../components/work';
import Hero from '../components/hero';

const IndexPage = () => (
  <Layout canonical="/">
    <Hero />
    <Testimonials />
    <About />
    <Work />
    <Contact />
  </Layout>
);

export default IndexPage;
